<ng-content select="[infiniteListHeader]"></ng-content>

<ng-container *ngIf="viewItems.length > 0; else emptyState">
  <div [ngClass]="itemsContainerClass">
    <ng-container
      *ngFor="
        let item of viewItems;
        let i = index;
        trackBy: trackByFn || defaultTrackBy
      "
    >
      <ng-container
        *ngTemplateOutlet="itemTemplate; context: { $implicit: item, index: i }"
      ></ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #emptyState>
  <ng-content select="[infiniteListEmpty]"></ng-content>
</ng-template>

<div #infiniteAnchor class="infinite-list-anchor"></div>

<div
  *ngIf="isLoading()"
  class="infinite-list-loading text-center text-gray-500 text-xs py-1"
>
  در حال بارگذاری...
</div>
